<template>  
  <div>
    <div class="row">
      <div class="col-10 mcontent">
        <q-expansion-item dense icon="check_circle_outline" :label="$t('global.Show')">
          <div class="row q-pa-sm">
            <div class="col-12 smallRow">
              <q-checkbox v-model="$store.state.showAlerts" :label="$t('global.Alerts')" />
            </div>
            <div class="col-12 smallRow">
              <q-checkbox v-model="$store.state.showIdles" :label="$t('global.Idles')" />
            </div>
             <div class="col-12 smallRow">
              <q-checkbox v-model="$store.state.showStops" :label="$t('global.Stops')" />
             </div>
             <div class="col-12 smallRow">
              <q-checkbox v-model="$store.state.showHeadings" :label="$t('global.Heading')" />
             </div>
          </div>
        </q-expansion-item>
      </div>
      <div class="col-2 mcontent">
        <q-btn
            class="float-right"
            icon="cached"
            color="primary"
            @click="refreshTrackingGroups()"
            :loading="$store.state.loading"
            size="sm"
          />
      </div>  
    </div>
    <div class="row mcontent">
      <div class="col-6 q-pa-xs">
        <DateInput :date.sync="dateFrom" :label="$t('global.DateFrom')"></DateInput>
      </div>
      <div class="col-6 q-pa-xs">
        <DateInput :date.sync="dateTo" :label="$t('global.DateTo')"></DateInput>
      </div>
    </div>
    <q-tree 
      class="mcontent"
      ref="HistoryTree"
      :nodes="trackingGroups" 
      :expanded.sync="propsExpanded"
      node-key="ID"
      :ticked.sync="ticked"
      :tick-strategy="tickStrategy" 
      @lazy-load="onLazyLoad"
      color="primary"
    >
    </q-tree>
  </div>
  
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'HistoryTree',
  data () {
    return {
      form: {
        SessionId: null,
      },
      selected: null,
      ticked: [],
      tickStrategy: 'strict',
      propsExpanded: [],
      trackingGroups: [],
      dateFrom: this.moment().add(-14, 'days'),
      dateTo: this.moment(),
    }
  },
  methods: {
    onLazyLoad ({ node, key, done, fail }) {
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.DateFrom = this.dateFrom.toISOString()
      this.form.DateTo = this.dateTo.toISOString()

      if(node.nodeType == 1){

        this.form.action = "DeviceTreeDeviceDate"
        this.form.TrackingGroupID = key.substring(2)
      }

      if(node.nodeType == 2){
        this.form.action = "DeviceTreeDay"
        this.form.DeviceID = key.substring(2)
      }
      if(node.nodeType == 3){
        this.form.action = "DeviceTreeHour"
        var res = key.split("_");
        this.form.DeviceID = res[1]
        this.form.Day = res[2]
      }

      if(node.nodeType == 4){
        this.form.action = "DeviceTreePosition"
        var res = key.split("_");
        this.form.DeviceID = res[3]
        this.form.Day = res[1]
        this.form.Hour = res[2]
      }
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            if(response.data.length > 0){
              done(response.data)
            }
            else
              fail()  
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadTrackingGroups(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "DeviceTreeTrackingGroupDate"
      this.form.DateFrom = this.dateFrom.toISOString()
      this.form.DateTo = this.dateTo.toISOString()
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.$store.state.loading = false
          if(response.status == 200){ 
              this.trackingGroups = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
              this.$store.state.loading = false
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
       this.$store.state.loading = false
        console.log(e);
      })
    },
    refreshTrackingGroups(){
      this.$store.state.loading = true
      this.$refs.HistoryTree.lazy = {}
      this.loadTrackingGroups()
    }
  },
  watch: {
    ticked: function (newValue, oldValue) {  
      if(newValue.length != oldValue.length){
        if(newValue.length > oldValue.length){
          console.log('add element')
          this.tempSelect = newValue.filter(x => !oldValue.includes(x));
          console.log('tempSelect: ' + this.tempSelect)
          var res = this.tempSelect[0].split("_");
          if(res[0] == '5'){
            eventBus.$emit('showPosition',  res[1])
          }
          if(res[0] == '4'){
              eventBus.$emit('showHour',  { day: res[1], hour: res[2], devId: res[3] })
          }
          if(res[0] == '3'){
              this.$store.state.loading = true
              eventBus.$emit('showDay',  { day: res[2], devId: res[1] })
          }
          
        }  
        else{
          if(this.tempSelect.length != 0){
            console.log('remove element')
            this.tempSelect = oldValue.filter(x => !newValue.includes(x));  
            console.log('tempSelect: ' + this.tempSelect)
            var res = this.tempSelect[0].split("_");
            if(res[0] == '5'){
              eventBus.$emit('removePosition',  res[1])
            }
            if(res[0] == '4'){
              eventBus.$emit('removeHour',  { day: res[1], hour: res[2], devId: res[3] })
            }
            if(res[0] == '3'){
                eventBus.$emit('removeDay',  { day: res[2], devId: res[1] })
            }           
          }
        }
      }
    },
    dateFrom: function (val) {
      this.$refs.HistoryTree.lazy = {}
      this.loadTrackingGroups()
    },
    dateTo: function (val) {
      this.$refs.HistoryTree.lazy = {}
      this.loadTrackingGroups()
    },
  },
  created () {
    this.loadTrackingGroups()
  },
}

</script>

<style scoped>
.mcontent{
  padding: 10px;
  padding-top: 0px;
}
.smallRow{
  margin-top: -15px;
}

</style>
